// extracted by mini-css-extract-plugin
module.exports = {"sidebar-thumb-width":"146","sidebarThumbWidth":"146","sidebar-thumb-height":"95","sidebarThumbHeight":"95","root":"JYNSn","grid-item":"_1G4D3","gridItem":"_1G4D3"};